import { render, staticRenderFns } from "./MemberContactInfo.vue?vue&type=template&id=58bad50d&scoped=true"
import script from "./MemberContactInfo.vue?vue&type=script&lang=js"
export * from "./MemberContactInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberContactInfo.vue?vue&type=style&index=0&id=58bad50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bad50d",
  null
  
)

export default component.exports